const API_URL =
  process.env.REACT_APP_REACT_ENV === 'production'
    ? process.env.REACT_APP_API_URL_PROD
    : process.env.REACT_APP_API_URL;

export default API_URL;
